<div class="ui-calls-list">
    <div class="ui-calls-list-table" *ngIf="callsInitStatus">
        <div class="ui-calls-list-table-container">
            <div class="ui-calls-list-table-header">
                <h3 class="ui-title">Llamadas de la factura {{invoice.receipt}}</h3>

                <div class="ui-nav"><button mat-flat-button color="primary" class="ui-button" (click)="onBack()"><mat-icon>chevron_left</mat-icon> Volver</button></div>
            </div>

            <div class="ui-bar-filters">
                <div class="el-left-filters">
                    <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterOriginNumber">Origen<i *ngIf="filters.originNumber != ''">: {{filters.originNumber}}</i> <mat-icon>expand_more</mat-icon></button>

                    <mat-menu #filterOriginNumber="matMenu">
                        <button mat-menu-item (click)="onFilterSelect('originNumber', '')">Todo</button>
                        <button mat-menu-item (click)="onFilterSelect('originNumber', item.name)" *ngFor="let item of filterNumbers; last as last">{{item.name}}</button>
                    </mat-menu>

                    <mat-form-field>
                        <mat-label>Número de destino</mat-label>
                        <input matInput [(ngModel)]="filters.destinationNumber" (blur)="onFilterSelect('destinationNumber', filters.destinationNumber)">
                        <button matSuffix mat-flat-button (click)="onFilterSelect('destinationNumber', '')" *ngIf="filters.destinationNumber != ''"><mat-icon>close</mat-icon></button>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Localidad de destino</mat-label>
                        <input matInput [(ngModel)]="filters.destinationName" (blur)="onFilterSelect('destinationName', filters.destinationName)">
                        <button matSuffix mat-flat-button (click)="onFilterSelect('destinationName', '')" *ngIf="filters.destinationName != ''"><mat-icon>close</mat-icon></button>
                    </mat-form-field>
                    
                    <mat-form-field>
                        <mat-label>Tipo</mat-label>
                        <mat-select [(ngModel)]="filters.type" (ngModelChange)="onFilterSelect('type', filters.type)" multiple>
                            <mat-option *ngFor="let item of filterTypes" [value]="item.name">{{item.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="date-multiple" >
                        <mat-label>Fecha</mat-label>
                        <mat-date-range-input [rangePicker]="filterDate" >
                            <input matStartDate placeholder="Desde" (focus)="filterDate.open()" [(ngModel)]="filters.date.start">
                            <input matEndDate placeholder="Hasta" (focus)="filterDate.open()" [(ngModel)]="filters.date.end" (dateChange)="onFilterSelect('date')">
                        </mat-date-range-input>
                        <button matSuffix mat-flat-button (click)="onFilterSelect('date', '')" *ngIf="filters.date.end != '' && filters.date.end != null"><mat-icon>close</mat-icon></button>
                        <mat-date-range-picker #filterDate></mat-date-range-picker>
                    </mat-form-field>
                </div>

                <div class="el-right-filters">
                    <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterExport">Exportar llamadas <mat-icon>expand_more</mat-icon></button>
    
                    <mat-menu #filterExport="matMenu">
                        <button mat-menu-item (click)="onDownload('xls')">Microsoft Excel (xlsx)</button>
                        <button mat-menu-item (click)="onDownload('cvs')">CVS separado por coma (cvs)</button>
                        <button mat-menu-item (click)="onDownload('json')">Archivo JSON (json)</button>
                    </mat-menu>
                </div>
            </div>

            <div class="ui-shadow" style="position:relative;">
                <div class="ui-spinner-container" *ngIf="callsUpdating">
                    <mat-spinner class="ui-spinner" [diameter]="25"></mat-spinner>
                </div>

                <div class="call" *ngIf="calls.length <= 0"><div class="call-empty">No existen llamadas para mostrar</div></div>

                <div class="call" *ngFor="let call of calls; last as last">
                    <div class="call-data">
                        <span class="call-number">{{call.destinationNumber}} ({{call.date | date:'dd/MM/yyyy HH:mm:ss'}})</span>
                        <span class="call-details">Desde {{call.originNumber}} ({{call.type}}: {{call.destination}})</span>
                    </div>

                    <div class="call-amount">
                        <span class="call-total">${{call.total | number:'1.2-2'}}</span>
                        <span class="call-indicators">{{call.minutes}} {{call.minutes > 1 ? 'minutos' : 'minuto'}}</span>
                    </div>
                </div>

                <mat-paginator *ngIf="calls.length > 0" [length]="callsTotal" [pageSize]="callsPageSize" [pageSizeOptions]="[25, 50, 75, 100]" (page)="onPaginationChange($event)"></mat-paginator>
            </div>
        </div>
    </div>

    <ui-screen-loader *ngIf="!callsInitStatus"></ui-screen-loader>
</div>